<template>
    <div>
        <span></span>
    </div>
</template>
<script>
export default {
    data(){
        return{
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            appConfig:{}
        }
    },
    mounted(){
        this.getConfig()
    },
    methods:{
        getConfig(){
            this.$axios({
                method: "POST",
                url: "/get/getCpAppConfig",
                data: {
                    appId: this.configInfo.app_id,
                },
                success: data => {
                    if (data.data.status == "success") {
                        this.appConfig = data.data.data
                        this.$emit('appConfig',this.appConfig)
                    }else{
                        this.$toast(data.data.message)
                    }
                }
            });
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/public/GetConfig.vue